export default __webpack_public_path__ + "static/media/ecfoundation2.c0a127bf.png";